import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { withStyles } from '@aura/components/styles'
import Grid from '@aura/components/grid'
import Button from '@aura/components/button'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import RegistrationContainer from '../../../../components/registration-container-mata'
import { useConfig } from '../../../../utils/config'
import styles from './styles'


const Component = ({
    classes,
}) => {
    const config = useConfig()
    const { t: translate } = useTranslation()

    const stepTitle = translate('registrationAnalytics.success')
    const stepVerbiage = (
        <>
            {translate('registrationAnalytics.successVerbiage')}{' '}
            <a href={`${config.mataMailTo}`}>{config.mataMailTo.split(':')[1]}.</a>
        </>
    )
    const history = useHistory()
    const orignalPath = window.location.pathname.split('/register')[0] + '/login'

    const handleBacktoSignIn = useCallback(() => {
        history.push(orignalPath)
    }, [])

    return (
        <Grid container spacing={0} direction="column" className={classes.gridContainerCentre}>
            <Grid item className={classes.registrationRoot} md={5} sm={8} xs={12}>
                <RegistrationContainer {...{ isMata: true, title: stepTitle, verbiage: stepVerbiage }}>
                    <Grid container className={classes.buttonContainer}>
                        <Button
                            className={classes.button}
                            color='primary'
                            onClick={handleBacktoSignIn}
                        >
                            {translate('registrationAnalytics.exit')}
                        </Button>
                    </Grid>
                </RegistrationContainer>
            </Grid>
        </Grid>
    )
}

Component.displayName = 'RequestSuccess'

Component.defaultProps = {
    data: {
        login: ''
    }
}


Component.propTypes = {
    classes: PropTypes.shape({
        actionRow: PropTypes.object,
        button: PropTypes.object,
        buttonContainer: PropTypes.object,
        contentDivider: PropTypes.object,
        fieldsContainer: PropTypes.object,
        passwordContainer: PropTypes.object,
        passwordError: PropTypes.object,
        passwordSuccess: PropTypes.object

    }),
}

export default withStyles(Component, styles)
